export default "__VITE_ASSET__BsU0x5vq__"